<template>
  <a-table class="ant-table" v-bind="$attrs">
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps || {}"></slot>
    </template>
  </a-table>
</template>

<script setup lang="ts">
defineOptions({
  name: 'AntTable',
  inheritAttrs: false
})
</script>

<style lang="less" scoped>
:deep(.ant-table-thead > tr > th) {
  background: #e2ebff !important;
}
</style>
